import React from "react";
import { Text, makeStyles, tokens } from "@fluentui/react-components";
import { Briefcase20Regular, Open16Regular } from "@fluentui/react-icons";
import { useGlobalStyles } from "../../utils/Theming";
import Icon from "../../blocks/Icon";
import VacancyLink from "./VacancyLink";

const useStyles = makeStyles({
  card: {
    display: "flex",
    alignItems: "center",
    padding: "10px 0",
    width: "100%",
  },
  info: {
    flexGrow: 1,
    marginLeft: "10px",
    overflow: "hidden",
  },
  status: {
    color: tokens.colorNeutralForeground2,
  },
  link: {
    fontWeight: "bold",
    alignSelf: "flex-start",
    marginLeft: "auto",
    color: tokens.colorNeutralForeground2,
  },
});

const VacancyItem = ({ vacancy }) => {
  const styles = useStyles();
  const globalStyles = useGlobalStyles();

  return (
    <div className={styles.card}>
      <Icon icon={<Briefcase20Regular />} />

      <div className={styles.info}>
        <Text className={globalStyles.truncateText} size={300} weight="semibold" block>{vacancy.title}</Text>
        <Text className={styles.status} block>{vacancy.status}</Text>
      </div>

      <VacancyLink vacancyUid={vacancy.uid} />
    </div>
  );
};

export default VacancyItem;
